export default "<mat-toolbar color=\"primary\" style=\"background: -webkit-linear-gradient(top, #344c72 0%,#2e486b 50%,#1d3041 100%);\">\n\n</mat-toolbar>"